var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"has-text-centered"},[_c('p',[_vm._v("Er lijkt iets verkeerd te zijn gegaan met het laden van de pagina.")]),_c('br'),_c('b-button',{attrs:{"type":"is-primary"},on:{"click":function($event){return _vm.reload()}}},[_vm._v("Herladen")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }